<template>
  <v-card
    class="dialog-card"
    style="overflow: hidden">
    <ModalHeader
      icon="mdi-cube-outline"
      modalTitle="Select Scene"
      @close="emit('close')" />
    <div class="mx-3 mb-3">
      <v-text-field
        v-model="search_s"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        @input="search_scenes()"
        hide-details
        filled
        style="border-width: 0px !important"
        dense
        class="mb-3"></v-text-field>
    </div>
    <div
      class="px-3 pb-3 modal-body"
      style="
        flex-direction: column;
        height: 460px;
        overflow-y: auto;
        justify-content: start;
      ">
      <WideCard
        v-for="item in scenes"
        :loading="false"
        :title="item.name"
        :icons="[GetLogo(deluge.items[item.did].scene_name.toLowerCase())]"
        @click="selected_item = item"
        :selected="selected_item?.uid === item.uid"
        :img="FindFirstAsset1(item)"
        :dense="true">
        <Tag
          v-for="frame in get_ch_frames(deluge.items[item.ch_did])"
          :key="frame"
          dense
          :color="frame.color"
          icon="mdi-picture-in-picture-top-right"
          :name="frame.nickname ? frame.nickname : 'Frame ' + frame.number" />
        <Tag
          color="#2d2d2d"
          dense
          icon="mdi-play-speed"
          :name="deluge.items[item.ch_did].name" />
      </WideCard>
    </div>
    <div class="modal-footer">
      <v-btn
        color="primary"
        block
        @click="emit('selected', selected_item)"
        variant="flat"
        :disabled="!selected_item">
        Select Scene
      </v-btn>
    </div>
  </v-card>
</template>
<script setup>
import { ref, onBeforeMount } from 'vue';
import { deluge } from '@/stores/deluge.js';
import WideCard from '../Shared/WideCard.vue';
import Tag from '../Shared/Tag.vue';
import ModalHeader from './Modals/ModalHeader.vue';
import { getThumbnailForScene } from '../../utils/thumbnails.js';

const emit = defineEmits(['selected', 'close']);
const props = defineProps(['exclude_channel', 'channel']);
const search_s = ref('');
const scenes = ref([]);
onBeforeMount(() => {
  search_scenes();
});
function GetLogo(scene_name) {
  for (const template in deluge.templates) {
    if (template == scene_name) {
      return deluge.templates[template].icon;
    }
  }
  return 'mdi-cube';
}
function search_scenes() {
  var dids = [];
  var temp_scenes = [];
  for (const id in deluge.items) {
    const item = deluge.items[id];
    if (
      item.scene_name &&
      item.ch_did !== props.exclude_channel &&
      item.ch_did &&
      item.name
    ) {
      if (deluge.items[id].scene_name) {
        if (
          deluge.items[id].name
            .toLowerCase()
            .includes(search_s.value.toLowerCase()) &&
          !dids.includes(deluge.items[id].did)
        ) {
          dids.push(deluge.items[id].did);
          temp_scenes.push(deluge.items[id]);
        }
      }
    }
  }
  temp_scenes.sort((a, b) => a.name.localeCompare(b.name));
  scenes.value = temp_scenes;
}
const selected_item = ref(undefined);
function get_ch_frames(ch) {
  let frames = [];
  for (const frame of Object.values(deluge.frames)) {
    if (frame.channel_id === ch.id) {
      frames.push(frame);
    }
  }
  return frames;
}
function FindFirstAsset1(scene) {
  const result = getThumbnailForScene(scene, deluge);
  return result.src;
}
</script>
